import { render, staticRenderFns } from "./ColonosLayout.vue?vue&type=template&id=00d60150"
import script from "./ColonosLayout.vue?vue&type=script&lang=js"
export * from "./ColonosLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports